import {
    getApplicationProduct,
    listApplicationProducts
} from './queries';
import {
    createApplicationProduct,
    deleteApplicationProduct,
    updateApplicationProduct,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {ApplicationProduct} from "../types.ts";
import {generateClient} from "aws-amplify/api";

export type ListApplicationProducts = {
    listApplicationProducts: { items: ApplicationProduct[] }
}

export type GetApplicationProduct = {
    getApplicationProduct: ApplicationProduct
}

export type CreateApplicationProduct = {
    createApplicationProduct: ApplicationProduct
}

export type UpdateApplicationProduct = {
    updateApplicationProduct: ApplicationProduct
}

export type DeleteApplicationProduct = {
    deleteApplicationProduct: string
}

const client = generateClient();

const normalizeFilter = (filter: { [key: string]: string }) => {
    return Object.keys(filter)
                 .reduce((acc: { [key: string]: string }, key: string) => {
                     if (filter[key] !== '') {
                         acc[key] = filter[key];
                     }
                     return acc;
                 }, {});

};

export const fetchRecords = async (filter?: { [key: string]: string }) => {

    // filter looks like this - {applicationId: 'XXXXXXXXXXXXX', productId: 'XXXXXXXXXXXXX'}

    let transformedFilter = {};
    if (typeof filter !== 'undefined') {
        transformedFilter = normalizeFilter(filter);
    }

    const response = await client.graphql<GraphQLQuery<ListApplicationProducts>>({
                                                                                     query: listApplicationProducts,
                                                                                     variables: {
                                                                                         filter: transformedFilter
                                                                                     },
                                                                                 });
    return response.data?.listApplicationProducts.items;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetApplicationProduct>>({
                                                                                   query: getApplicationProduct,
                                                                                   variables: {id: id},
                                                                               });
    return response.data?.getApplicationProduct;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateApplicationProduct>>({
                                                                                      query: createApplicationProduct,
                                                                                      variables: {input: payload},
                                                                                  });
    return response.data?.createApplicationProduct;
};

export const update = async (_id: string, record: ApplicationProduct) => {

    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateApplicationProduct>>({
                                                                                      query: (updateApplicationProduct),
                                                                                      variables: {input: record},
                                                                                  });
    return response.data?.updateApplicationProduct;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteApplicationProduct>>({
                                                                                      query: (deleteApplicationProduct),
                                                                                      variables: {input: {id: id}},

                                                                                  });
    return response.data?.deleteApplicationProduct;
};
